export const nodeAPI = 'https://tabta-api.orientaloutsourcing.in/api/'
export const directus = 'https://api-dev.tabta.net/'